import{styled as o}from"@mui/joy";import e from"@mui/joy/Stack";var t=o(e)(({theme:o})=>({flexDirection:"row",gap:o.spacing(1),flexFlow:"row","& > *":{flex:1}}));export{t as StyledDateSection};
//# sourceMappingURL=DateSection.js.map